import { z } from 'zod';
import { nullishToEmpty } from './utils';

export const documentTextSchema = z.object({
  operationId: z.preprocess(
    nullishToEmpty(''),
    z.union([z.string().min(1), z.number()], {
      required_error: 'Operation ID',
      invalid_type_error: 'Operation ID',
    }),
  ),
  instanceId: z.preprocess(
    nullishToEmpty(''),
    z.string({ required_error: 'Instance ID' }).min(1, 'Instance ID'),
  ),
  document: z.preprocess(
    nullishToEmpty(''),
    z.string({ required_error: 'Document' }).min(1, 'Document'),
  ),
  sqlId: z.string().nullish(),
  sqlTextHashId: z.string().nullish(),
});

export type DocumentTextSchema = z.infer<typeof documentTextSchema>;
